/**
 * AMAÇ: İlk gelişte URL'deki utm_* parametrelerini yakalayıp localStorage'a yazar.
 * Kullanıcı birkaç sayfa gezip daha sonra kayıt/giriş yapsa bile o event, hangi
 * kampanyadan geldiğini (ilk temas) taşımaya devam eder — sonraki ziyaretlerde
 * (utm parametresi olmayan URL) eski değer korunur, üzerine boş yazılmaz.
 */
const STORAGE_KEY = 'streak_utm';

export const captureUtm = () => {
  const params = new URLSearchParams(window.location.search);
  const utm = {
    utm_source:   params.get('utm_source')   || undefined,
    utm_medium:   params.get('utm_medium')   || undefined,
    utm_campaign: params.get('utm_campaign') || undefined,
  };
  if (utm.utm_source || utm.utm_medium || utm.utm_campaign) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
  }
};

export const getStoredUtm = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

captureUtm();
